export default {
	namespaced: true,
	state: {
		paymentModes: [],
		payStyles: [],
	},

	mutations:{
		/**
		 * [setPayStyles description]
		 * @param {[type]} state     [description]
		 * @param {[type]} payStyles [description]
		 */
		setPayStyles(state, payStyles) {
			state.payStyles= payStyles
		},

		/**
		 * [setPaymentModes description]
		 * @param {[type]} state        [description]
		 * @param {[type]} paymentModes [description]
		 */
		setPaymentModes(state, paymentModes) {
			state.paymentModes= paymentModes
		}
	},
	getters:{
		/**
		 * [payStyles description]
		 * @param  {[type]} state [description]
		 * @return {[type]}       [description]
		 */
		payStyles(state) {
			return state.payStyles
		},

		/**
		 * [paymentModes description]
		 * @param  {[type]} state [description]
		 * @return {[type]}       [description]
		 */
		paymentModes(state) {
			return state.paymentModes
		}
	},
	actions: {
		/**
		 * [get_file description]
		 * @param  {[type]} options.commit  [description]
		 * @param  {[type]} options.getters [description]
		 * @param  {[type]} url             [description]
		 * @return {[type]}                 [description]
		 */
		get_file({commit, getters}, url) {
			return this._vm.$http.post('/file', { url },{
				responseType: 'blob'
			})
		},
		/**
		 * [get_pay_styles description]
		 * @param  {[type]} options.commit  [description]
		 * @param  {[type]} options.getters [description]
		 * @param  {[type]} payload         [description]
		 * @return {[type]}                 [description]
		 */
		get_pay_styles({commit, getters}, payload) {
			if(getters['payStyles'].length) {
				return Promise.resolve(getters['payStyles'])
			}

			return this._vm.$http.get('loan-applications/utility/paystyle')
				.then(response => {
					commit('setPayStyles', response.data)
					return response.data
				})
		},

		/**
		 * [get_payment_modes description]
		 * @param  {[type]} options.commit  [description]
		 * @param  {[type]} options.getters [description]
		 * @param  {[type]} payload         [description]
		 * @return {[type]}                 [description]
		 */
		get_payment_modes({commit, getters}, payload) {
			if(getters['paymentModes'].length) {
				return Promise.resolve(getters['paymentModes'])
			}
			return this._vm.$http.get('loan-applications/utility/payment-modes')
				.then(response => {
					commit('setPaymentModes', response.data)
					return response.data
				})
		}
	},

}